module.exports = __webpack_public_path__ + "static/media/nodeproj.550e1601.jpg";